import { Modal , Row , Col , Divider, Carousel } from 'antd'
import React , {useRef , useState} from 'react'
import './custom.scss'
import {MdOutlineArrowBackIos , MdOutlineArrowForwardIos} from 'react-icons/md';
import {FaCalendarDay , FaTachometerAlt , FaCarCrash ,FaCar, FaUsers} from 'react-icons/fa';
import {GiGearStickPattern , GiGears} from 'react-icons/gi';
import {IoMdPin} from'react-icons/io';
import NoImage from './noImage';

const BicycleView = (props) => {

    const {data , title , onCancel , visible} = props
    // const [slide, setSlide] = useState(0);
    const slider = useRef();

    const next = () =>{
        slider.current.next()
    }

    const prev = () =>{
        slider.current.prev()
    }


    return (
        <Modal
            title={title}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            className='preview-modal'
        >
            {!Object.entries(data).length? null
            :<div className='product-container'>
                <div className='image-container'>
                    {!data.product_image_urls.length?
                        <NoImage/>
                        :
                        <Carousel
                            ref={ref => {
                                slider.current = ref;
                            }}
                        >
                            {data.product_image_urls.map((image , i)=>
                                <img key={i} src={image.metadata.image_url}/>
                            )}
                        </Carousel>
                    }
                </div>

                <div className='header-name-container'>
                    <div>
                        <p className='type'>{data?.vehicle_type}</p>
                        <p className='name'>{data?.product_name}</p>
                    </div>
                    <div>
                        <div className='slider-icon-container'>
                            <div className='slider-icon' onClick={prev}>
                                <MdOutlineArrowBackIos/>
                            </div>
                            <div className='slider-icon' onClick={next}>
                                <MdOutlineArrowForwardIos/>
                            </div>
                        </div>

                        <p className='price'>S$ {data?.product_price?.toLocaleString()}</p>
                    </div>
                </div>

                <div className='overview'>
                    <p className='header-section'>OVERVIEW</p>
                    <p>{data?.description}</p>
                </div>

                <Divider/>

                <div className='overview'>
                    <p className='header-section'>SPECIFICATIONS</p>
                    <Row gutter={[10,10]}>                        
                        <Col span={8}>
                            <div className='tech-specs-container'>
                                <div>
                                    <p className='tech-spec-label'>CONDITION</p>
                                    <p className='tech-spec-value'>{data?.condition}</p>
                                </div>
                            </div>
                        </Col>
                        <Col span={8}>
                            <div className='tech-specs-container'>
                                <div>
                                    <p className='tech-spec-label'>BICYCLE TYPE</p>
                                    <p className='tech-spec-value'>{data?.type}</p>
                                </div>
                            </div>
                        </Col>
                        <Col span={8}>
                            <div className='tech-specs-container'>
                                <div>
                                    <p className='tech-spec-label'>BRAND</p>
                                    <p className='tech-spec-value'>{data?.brand}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Divider/>

                <div className='overview'>
                    <p className='header-section'>ACCESSORIES</p>
                    <p>{data?.accessories}</p>
                </div>

                <Divider/>
                <div className='overview'>
                    <p className='header-section'>FEATURES</p>
                    <p>{data?.Description}</p>
                </div>

            </div>
            }
        </Modal>
    )
}

export default BicycleView
